import { render, staticRenderFns } from "./main-business.vue?vue&type=template&id=2927f24a&scoped=true"
import script from "./main-business.vue?vue&type=script&lang=js"
export * from "./main-business.vue?vue&type=script&lang=js"
import style0 from "./main-business.vue?vue&type=style&index=0&id=2927f24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2927f24a",
  null
  
)

export default component.exports